import { HeaderNavItem } from '../sportsbook.models';

export const HEADER_NAV_ITEMS: readonly HeaderNavItem[] = [
  { label: 'Sports', labelKey: 'navigation.primary.sports', route: '/', active: true },
  {
    label: 'Results',
    labelKey: 'navigation.primary.results',
    children: [
      { label: 'My Tickets', labelKey: 'menu.myTickets', route: '/tickets' },
      { label: 'Results', labelKey: 'menu.results', route: '/results' }
    ]
  },
  {
    label: 'Funding',
    labelKey: 'navigation.primary.funding',
    children: [
      { label: 'Transactions', labelKey: 'navigation.secondary.transactions', route: '/transactions' },
      { label: 'Deposit', labelKey: 'navigation.secondary.deposit' },
      { label: 'Withdraw', labelKey: 'navigation.secondary.withdraw' }
    ]
  },
  { label: 'Settings', labelKey: 'navigation.primary.settings' }
];
